import React, { Component } from 'react'
import auth from './dashboard/auth'

export default class Deregister extends Component {

    constructor(props){
        super(props);
        this.state = {
            isLoading: true,
            message: ""
        } 
    }

    componentDidMount = () => {

        let CLASS = this;
        const {date, day, id, time} = this.props.match.params;
            auth.firestore().collection(day).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots

                    try{

                    let object = doc.data()[date];

                    console.log("Main object", object)
                    let key = -1;
                    //search for the key
                    for(let i=0; i < object.length; i++){
                        
                        if(id == object[i].id){
                            key = i;
                        }
                    }

                    console.log(key)

                     if(key != -1){
                        // Performing deletion after getting object and key
                        object.splice(key, 1);

                        var cityRef = auth.firestore().collection(day).doc(time);
    
                        //Remove the 'capital' field from the document
                        var removeCapital = cityRef.update({
                            [date]: object
                        }).then((values) => {
                           CLASS.setState({
                               message : 'Sie haben Ihre Buchung erfolgreich gelöscht.',
                               isLoading: false
                           })
                        })
                     }else{
                        CLASS.setState({
                            message : 'Sie haben Ihre Buchung bereits gelöscht.',
                            isLoading: false
                        })
                     }


                    }catch(e){
                        CLASS.setState({
                            message : 'Mit Ihrer Anfrage stimmt etwas nicht. Vielleicht ist der Link kaputt.',
                            isLoading: false
                        })
                    }
                     
                 });
            });
 
    }

    render() {
        return (
            <div style={{color:'white', textAlign:'center', margin: 20}}>
               {!this.state.isLoading ? this.state.message : ""}
            </div>
        )
    }
}
